var map = {
	"./AllMediaDesk_Logo_light_background_RGB.svg": "uBWJ",
	"./CSIRO_Logo.svg": "8PO0",
	"./Ministry_of_Health_(Vietnam)_Logo.svg": "wfdX",
	"./URT__white solid.svg": "juY5",
	"./ak_tech_logo.svg": "EyRh",
	"./daphovina_logo.svg": "LN5q",
	"./momo.svg": "aqc7",
	"./unimelb_logo.svg": "YyGw"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Pp59";